import React from 'react';

const ContactTypeSelector = ({ contactType, setContactType }) => {
    const types = ['Number', 'Personalized', 'Segment'];
    return (
        <div style={styles.wrapper}>
            <label style={styles.label}>Type of Contacts</label>
            <div style={styles.options}>
                {types.map((type) => (
                    <label key={type} style={{ ...styles.option, ...(contactType === type ? styles.optionActive : {}) }}>
                        <input
                            type="radio"
                            name="contactType"
                            value={type}
                            checked={contactType === type}
                            onChange={(e) => setContactType(e.target.value)}
                            style={{ display: 'none' }}
                        />
                        <span style={{ ...styles.dot, ...(contactType === type ? styles.dotActive : {}) }}></span>
                        {type}
                    </label>
                ))}
            </div>
        </div>
    );
};

const styles = {
    wrapper: { marginBottom: '20px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#374151', display: 'block', marginBottom: '10px' },
    options: { display: 'flex', gap: '10px', flexWrap: 'wrap' },
    option: { display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 16px', border: '1.5px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#374151', fontWeight: '500', transition: 'all 0.15s', userSelect: 'none' },
    optionActive: { border: '1.5px solid #1565c0', background: '#eff6ff', color: '#1565c0' },
    dot: { width: '14px', height: '14px', borderRadius: '50%', border: '2px solid #d1d5db', flexShrink: 0 },
    dotActive: { border: '4px solid #1565c0', background: 'white' },
};

export default ContactTypeSelector;
